import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { API_URL } from '@core/config/api-url.token';
import { API_ENDPOINTS } from '@shared/constants/api-endpoints.const';
import { Observable } from 'rxjs';
import { NotificationSettingsDto, UpdateNotificationSettingsRequestDto } from '../../dtos/notification-settings.dto';

@Injectable()
export class NotificationSettingsRemoteDatasource {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(API_URL);

  public get(organizationId: number): Observable<NotificationSettingsDto> {
    return this.http.get<NotificationSettingsDto>(
      `${this.apiUrl}${API_ENDPOINTS.notificationSettings.get(organizationId)}`,
    );
  }

  public update(organizationId: number, payload: UpdateNotificationSettingsRequestDto): Observable<NotificationSettingsDto> {
    return this.http.put<NotificationSettingsDto>(
      `${this.apiUrl}${API_ENDPOINTS.notificationSettings.get(organizationId)}`,
      payload,
    );
  }

  public sendTest(organizationId: number): Observable<void> {
    return this.http.post<void>(
      `${this.apiUrl}${API_ENDPOINTS.notificationSettings.test(organizationId)}`,
      null,
    );
  }
}
